import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { message, Spin } from 'antd';
import { SignOutIcon, CaretDownIcon, getIconComponent } from './icons';

import Menus from '../../infra/menus/Menus';
import { get } from '../../services/http/RevendaService';
import {
  getUser,
  isBackOfficeOrUpgasEmployee,
  isOrganization,
  isUpgasEmployee,
} from '../../services/UserService';
import logoUpgas from '../../../assets/images/logo-upgas.png';
import './SideBar.scss';

class SideBar extends React.Component {
  constructor(props) {
    super(props);

    const openKeys = localStorage.getItem('openKeys')
      ? JSON.parse(localStorage.getItem('openKeys'))
      : [];
    const selectedKeys = localStorage.getItem('selectedKeys')
      ? JSON.parse(localStorage.getItem('selectedKeys'))
      : [];

    this.state = {
      organizationResales: [],
      openKeys,
      selectedKeys,
    };

    this.normalizeLocalStorageSelectedKeys();
  }

  componentDidMount() {
    this.syncSelectedKeyFromRoute();

    if (isOrganization()) {
      this.getInstance = get(1, 10, null);
      this.getInstance.promise
        .then((dataSource) =>
          this.setState({ organizationResales: dataSource.items }),
        )
        .catch((error) => message.error(error.errorMessage));
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.syncSelectedKeyFromRoute();
    }
  }

  componentWillUnmount() {
    if (this.getInstance) {
      this.getInstance.cancel();
    }
  }

  syncSelectedKeyFromRoute = () => {
    const { pathname } = this.props.location;
    const allItems = Menus(this.state.organizationResales).reduce((acc, menu) =>
      acc.concat(
        menu.childs && menu.childs.length
          ? menu.childs.map((child) => ({ ...child, parentKey: menu.key }))
          : [menu],
      ), []);
    const match = allItems
      .filter(
        (item) => item.url && item.url !== '' && pathname.startsWith(item.url),
      )
      .sort((a, b) => b.url.length - a.url.length)[0];

    if (!match) return;

    const selectedKeys = [match.key];
    const openKeys = match.parentKey ? [match.parentKey] : [];

    this.setState({ selectedKeys, openKeys });
    localStorage.setItem('selectedKeys', JSON.stringify(selectedKeys));
    localStorage.setItem('openKeys', JSON.stringify(openKeys));
  };

  normalizeLocalStorageSelectedKeys = () => {
    const selectedKeys = localStorage.getItem('selectedKeys');

    if (selectedKeys && !Array.isArray(JSON.parse(selectedKeys))) {
      localStorage.setItem('selectedKeys', JSON.stringify([selectedKeys]));
    }
  };

  isMobile = () => window.innerWidth <= 768;

  closeMobile = () => {
    if (this.isMobile() && this.props.onToggle) {
      this.props.onToggle();
    }
  };

  changeSelectedKey = (menu) => {
    const { key, notSelectable } = menu;
    const isIncludedOnOpenKeys = this.state.openKeys.includes(key);

    if (!isIncludedOnOpenKeys) {
      this.setState({ openKeys: [] });
      localStorage.setItem('openKeys', JSON.stringify([]));
    }

    if (notSelectable) return;
    localStorage.setItem('selectedKeys', JSON.stringify([key]));
    this.setState({ selectedKeys: [key] });
    this.closeMobile();
  };

  toggleSubMenu = (key) => {
    const { openKeys } = this.state;
    const isOpen = openKeys.includes(key);
    const newOpenKeys = isOpen ? [] : [key];

    localStorage.setItem('openKeys', JSON.stringify(newOpenKeys));
    this.setState({ openKeys: newOpenKeys });
  };

  isMenuActive = (menu) => {
    const { selectedKeys } = this.state;
    return selectedKeys.includes(menu.key);
  };

  isSubMenuActive = (menu) => {
    const { selectedKeys } = this.state;
    return menu.childs.some((child) => selectedKeys.includes(child.key));
  };

  renderHeader = () => {
    const { isCollapsed } = this.props;
    const user = getUser();
    const subtitle = isBackOfficeOrUpgasEmployee()
      ? 'UpGás Admin'
      : 'UpGás Backoffice';

    return (
      <div className='sidebar-header'>
        <img className='sidebar-header-logo' src={logoUpgas} alt='UpGás' />
        {!isCollapsed && (
          <div className='sidebar-header-info'>
            <p className='sidebar-header-name' title={user.name}>
              {user.name}
            </p>
            <p className='sidebar-header-subtitle'>{subtitle}</p>
          </div>
        )}
      </div>
    );
  };

  renderNavItem = (menu) => {
    const { isCollapsed } = this.props;
    const isActive = this.isMenuActive(menu);
    const IconComponent = getIconComponent(menu.icon);

    if (menu.component) {
      const CustomComponent = menu.component;
      return (
        <CustomComponent
          key={menu.key}
          menu={menu}
          onClick={() => this.changeSelectedKey(menu)}
          isActive={isActive}
          isCollapsed={isCollapsed}
        />
      );
    }

    if (menu.propAction) {
      return (
        <button
          key={menu.key}
          className={`nav-item ${isActive ? 'active' : ''}`}
          onClick={() => {
            this.changeSelectedKey(menu);
            this.props[menu.propAction]();
            this.closeMobile();
          }}>
          <span className='nav-item-icon'>
            {IconComponent && <IconComponent weight='fill' />}
          </span>
          {!isCollapsed && <span className='nav-item-text'>{menu.text}</span>}
        </button>
      );
    }

    return (
      <Link
        key={menu.key}
        to={menu.url}
        className={`nav-item ${isActive ? 'active' : ''} ${menu.disabled ? 'disabled' : ''}`}
        onClick={(e) => {
          if (menu.disabled) {
            e.preventDefault();
            return;
          }
          this.changeSelectedKey(menu);
        }}>
        <span className='nav-item-icon'>
          {IconComponent && <IconComponent weight='fill' />}
        </span>
        {!isCollapsed && <span className='nav-item-text'>{menu.text}</span>}
      </Link>
    );
  };

  renderSubMenu = (menu) => {
    const { isCollapsed } = this.props;
    const { openKeys } = this.state;
    const isOpen = openKeys.includes(menu.key);
    const isActive = this.isSubMenuActive(menu);
    const IconComponent = getIconComponent(menu.icon);

    return (
      <div key={menu.key}>
        <button
          className={`nav-item ${isActive ? 'active' : ''}`}
          onClick={() => this.toggleSubMenu(menu.key)}>
          <span className='nav-item-icon'>
            {IconComponent && <IconComponent weight='fill' />}
          </span>
          {!isCollapsed && (
            <>
              <span className='nav-item-text'>{menu.text}</span>
              <CaretDownIcon
                size={14}
                className={`nav-item-chevron ${isOpen ? 'open' : ''}`}
              />
            </>
          )}
        </button>
        {isOpen && !isCollapsed && (
          <div className='submenu-children'>
            {menu.childs.map((child) => {
              const isChildActive = this.state.selectedKeys.includes(child.key);

              return (
                <Link
                  key={child.key}
                  to={child.url}
                  className={`nav-item ${isChildActive ? 'active' : ''}`}
                  onClick={() =>
                    this.changeSelectedKey({ ...menu, key: child.key })
                  }>
                  <span className='nav-item-text'>{child.text}</span>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  render() {
    const { organizationResales } = this.state;
    const { isCollapsed, loading, employeeMenus } = this.props;
    const menus = isUpgasEmployee()
      ? Menus(organizationResales)
        .filter(({ menuEnum, childs }) =>
          menuEnum
            ? employeeMenus.includes(menuEnum)
            : childs.some((child) => employeeMenus.includes(child.menuEnum)),
        )
        .map((menu) =>
          menu.childs.length > 0
            ? { ...menu, childs: menu.childs.filter((child) => !child.menuEnum || employeeMenus.includes(child.menuEnum)) }
            : menu,
        )
      : Menus(organizationResales);

    return (
      <div className={`custom-sidebar ${isCollapsed ? 'collapsed' : ''}`}>
        {loading ? (
          <Spin className='sidebar-spin' size='large' />
        ) : (
          <>
            {this.renderHeader()}
            <nav className='sidebar-nav'>
              {menus.map((menu) => {
                if (menu.childs.some((x) => x)) {
                  return this.renderSubMenu(menu);
                }
                return this.renderNavItem(menu);
              })}
              <button className='nav-item' onClick={() => { this.props.logOut(); this.closeMobile(); }}>
                <span className='nav-item-icon'>
                  <SignOutIcon size={20} />
                </span>
                {!isCollapsed && <span className='nav-item-text'>Sair</span>}
              </button>
            </nav>
          </>
        )}
      </div>
    );
  }
}

export default withRouter(SideBar);
